import { useAppSelector } from '@/hooks/use-app-selector'
import { removeSnackbar } from '@/states/snackbar.slice'
import { Alert, AlertColor, Box, Snackbar } from '@mui/material'
import React from 'react'
import { useDispatch } from 'react-redux'

// Snackbar.tsx
export const SnackbarComponent: React.FC = () => {
  const dispatch = useDispatch()
  const messages = useAppSelector((state) => state.snackbar.messages)

  return (
    <Box
      display='grid'
      gap={1}
      gridTemplateColumns='1fr'
      alignItems='end'
      justifyContent='end'
      alignContent='end'
      p={4}
      sx={{
        position: 'fixed',
        bottom: 0,
        right: 0,
        zIndex: 1000,
        height: '100%',
        pointerEvents: 'none',
      }}
    >
      {messages?.map((snackbar, index) => (
        <Snackbar
          key={snackbar.message + index}
          open={true}
          autoHideDuration={2000}
          onClose={() => dispatch(removeSnackbar(index))}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          sx={{
            position: 'relative',
            pointerEvents: 'initial',
          }}
        >
          <Alert
            onClose={() => dispatch(removeSnackbar(index))}
            severity={snackbar.severity as AlertColor}
            sx={{
              width: '100%',
              maxWidth: 500, // Limit max width
              borderRadius: 2,
            }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      ))}
    </Box>
  )
}
